import { render, staticRenderFns } from "./ProductsHome.vue?vue&type=template&id=114923fc&scoped=true"
import script from "./ProductsHome.vue?vue&type=script&lang=js"
export * from "./ProductsHome.vue?vue&type=script&lang=js"
import style0 from "./ProductsHome.vue?vue&type=style&index=0&id=114923fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114923fc",
  null
  
)

export default component.exports